import {from, Observable} from "rxjs";
import {Geolocation} from "@capacitor/geolocation";
import {GeolocationService} from "@app/core/delivery-point/domain/geolocation.service";
import {map} from "rxjs/operators";

export class CapacitorGeolocationService implements GeolocationService{

    /**
     * Get the user's current position using GPS if it is available.
     */
    getCurrentPosition(): Observable<GeolocationPosition> {
        return from(Geolocation.getCurrentPosition()).pipe(
            map(position => {
                return  {
                    coords: {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        altitude: position.coords.altitude,
                        accuracy: position.coords.accuracy,
                        altitudeAccuracy: position.coords.altitudeAccuracy ?? null,
                        heading: position.coords.heading,
                        speed: position.coords.speed,
                    },
                    timestamp: position.timestamp,
                }
            })
        )
    }

}